import axios from "axios";
import * as PATH from "../helpers/APIURL";
import {apiUserAuth} from "../helpers/Utils";

export default class AuthService {

    static login = data => {
        return axios.post(`${PATH.USER_SIGNIN_URL}`, data, {headers: apiUserAuth()});
    }

    static signup = data => {
        return axios.post(`${PATH.RESTAURANT_OWNER_SIGNUP_URL}`, data, {headers: apiUserAuth()});
    }

    static otpVerify = params => {
        return axios.post(`${PATH.OTP_VERIFY_URL}`, null, {params, headers: apiUserAuth()});
    }

    static resendOTP = params => {
        return axios.post(`${PATH.RESEND_OTP_URL}`, null, {params, headers: apiUserAuth()});
    }

    static resetPassword = params => {
        return axios.post(`${PATH.RESET_PASSWORD}`, null, {params});
    }

    static resetPasswordOTPVerify = (params, data) => {
        return axios.post(`${PATH.RESET_PASSWORD_OTP_VERIFY}`, data, {params, headers: apiUserAuth()});
    }

}
